/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-C5chbmyn.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle, _path12, _path13, _path14, _path15, _path16, _circle2, _path17, _circle3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle4, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path50, _path51, _path52, _path53, _path54, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _circle18, _circle19, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _circle20, _circle21, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _circle22, _path221, _path222, _path223, _path224, _path225;
const SkipForwardFilled = /*#__PURE__*/React.forwardRef(function SkipForwardFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H30V28H28zM5 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 015 28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardFilled.propTypes = iconPropTypes;
}
const SkipForwardOutline = /*#__PURE__*/React.forwardRef(function SkipForwardOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.6011L15.9409 16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardOutline.propTypes = iconPropTypes;
}
const SkipForwardOutlineFilled = /*#__PURE__*/React.forwardRef(function SkipForwardOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.301L15.941 16 10 12.699 10 19.301z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.601L15.9409 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardOutlineFilled.propTypes = iconPropTypes;
}
const SkipForwardOutlineSolid = /*#__PURE__*/React.forwardRef(function SkipForwardOutlineSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardOutlineSolid.propTypes = iconPropTypes;
}
const SkipForwardSolidFilled = /*#__PURE__*/React.forwardRef(function SkipForwardSolidFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardSolidFilled.propTypes = iconPropTypes;
}
const Sleet = /*#__PURE__*/React.forwardRef(function Sleet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H8V26H6zM8 26H10V28H8zM10 28H12V30H10zM10 24H12V26H10zM6 28H8V30H6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0A6.4973 6.4973 0 008.5 22h8.8818L16.106 24.5527a1 1 0 101.7885.8946L19.6177 22H23.5A6.4974 6.4974 0 0024.8008 9.1362zM23.5 20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sleet.propTypes = iconPropTypes;
}
const Slisor = /*#__PURE__*/React.forwardRef(function Slisor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Slisor.propTypes = iconPropTypes;
}
const Slm = /*#__PURE__*/React.forwardRef(function Slm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9zM14 21L14 9 12 9 12 23 20 23 20 21zM8 23H2v-2h6v-4H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6v2H4v4h4c1.1 0 2 .9 2 2v4C10 22.1 9.1 23 8 23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Slm.propTypes = iconPropTypes;
}
const Smell = /*#__PURE__*/React.forwardRef(function Smell({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Smell.propTypes = iconPropTypes;
}
const Smoke = /*#__PURE__*/React.forwardRef(function Smoke({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L23.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L27.8 26.4A1 1 0 0127.001 28zM22.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L18.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L22.8 26.4A1 1 0 0122.001 28zM17.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L13.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L17.8 26.4A1 1 0 0117.001 28zM12.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762A6.9956 6.9956 0 009.0142 6.6855L8.2 5.6A1 1 0 119.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L12.8 26.4A1 1 0 0112.001 28zM7.001 28A.998.998 0 016.2 27.6l-.8145-1.086a8.9976 8.9976 0 01-1.6-7.2856l1.4736-6.8762A6.9956 6.9956 0 004.0142 6.6855L3.2 5.6A1 1 0 114.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856L5.7412 19.6474a6.9956 6.9956 0 001.2446 5.6668L7.8 26.4A1 1 0 017.001 28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Smoke.propTypes = iconPropTypes;
}
const WatsonHealthSmoothing = /*#__PURE__*/React.forwardRef(function WatsonHealthSmoothing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSmoothing.propTypes = iconPropTypes;
}
const WatsonHealthSmoothingCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthSmoothingCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30a11.8932 11.8932 0 01-4.1035-.72L14.58 27.4A9.9725 9.9725 0 0018 28zM22.1484 29.2637l-.6914-1.877a9.9556 9.9556 0 002.9973-1.748l1.2916 1.5268A11.9525 11.9525 0 0122.1484 29.2637zM10.2893 27.1951A12.0141 12.0141 0 017.61 24.0078l1.73-1.0029a10.0236 10.0236 0 002.2347 2.6584zM28.4133 23.967l-1.7343-.9956a9.9159 9.9159 0 001.176-3.2641l1.9712.3388A11.8956 11.8956 0 0128.4133 23.967zM6.1821 20.0925A12.1282 12.1282 0 016.1777 15.93l1.9707.3423a10.1214 10.1214 0 00.0035 3.4738zM27.8447 16.2339a9.9019 9.9019 0 00-1.1953-3.2564l1.7285-1.0063a11.9029 11.9029 0 011.4361 3.9121zM9.3313 13.0107l-1.7324-.999a12.01 12.01 0 012.6738-3.1931l1.2886 1.53A10.01 10.01 0 009.3313 13.0107zM24.4094 10.3237a9.96 9.96 0 00-3.0088-1.7309l.68-1.8809a11.9491 11.9491 0 013.6118 2.0772zM14.562 8.6064l-.6875-1.8779A12.1031 12.1031 0 0118 6V8A10.0875 10.0875 0 0014.562 8.6064zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSmoothingCursor.propTypes = iconPropTypes;
}
const Snooze = /*#__PURE__*/React.forwardRef(function Snooze({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.965H26.499V9.036999999999999H24.5z",
    transform: "rotate(-44.945 25.5 6.5)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.965 5.501H9.036999999999999V7.5H3.965z",
    transform: "rotate(-45.055 6.5 6.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Snooze.propTypes = iconPropTypes;
}
const Snow = /*#__PURE__*/React.forwardRef(function Snow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Snow.propTypes = iconPropTypes;
}
const SnowBlizzard = /*#__PURE__*/React.forwardRef(function SnowBlizzard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H15V12H13zM15 12H17V14H15zM17 14H19V16H17zM17 10H19V12H17zM13 14H15V16H13zM3 26H5V28H3zM5 28H7V30H5zM7 30H9V32H7zM7 26H9V28H7zM3 30H5V32H3zM23 26H25V28H23zM25 28H27V30H25zM27 30H29V32H27zM27 26H29V28H27zM23 30H25V32H23zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM13 26H15V28H13zM15 28H17V30H15zM17 30H19V32H17zM17 26H19V28H17zM13 30H15V32H13z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowBlizzard.propTypes = iconPropTypes;
}
const SnowHeavy = /*#__PURE__*/React.forwardRef(function SnowHeavy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H6V28H4zM6 28H8V30H6zM8 30H10V32H8zM8 26H10V28H8zM4 30H6V32H4zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM14 26H16V28H14zM16 28H18V30H16zM18 30H20V32H18zM18 26H20V28H18zM14 30H16V32H14z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowHeavy.propTypes = iconPropTypes;
}
const SnowScattered = /*#__PURE__*/React.forwardRef(function SnowScattered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM20 0H22V3H20zM29 10.001H32V12.001H29z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 16.233H29.732V18.233H26.732z",
    transform: "rotate(-135 28.232 17.233)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.268 3.768H15.268V5.768H12.268z",
    transform: "rotate(-135 13.768 4.768)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowScattered.propTypes = iconPropTypes;
}
const SnowScatteredNight = /*#__PURE__*/React.forwardRef(function SnowScatteredNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM29.8439 13.0347a1.517 1.517 0 00-1.23-.8658 5.3552 5.3552 0 01-3.4095-1.7158 6.4655 6.4655 0 01-1.286-6.3926 1.6025 1.6025 0 00-.2989-1.5459 1.4543 1.4543 0 00-1.36-.4931l-.0191.0039a7.7685 7.7685 0 00-5.8847 5.5737A7.3706 7.3706 0 0013.5 7a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 24H19a6.0066 6.0066 0 006-6c0-.0571-.0123-.1113-.0139-.1685a7.5076 7.5076 0 004.7611-3.2768A1.5369 1.5369 0 0029.8439 13.0347zM19 22H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 22zm5.5974-6.1289a5.9661 5.9661 0 00-3.948-3.627 7.49 7.49 0 00-2.489-3.58 5.9018 5.9018 0 013.6381-4.4473 8.4577 8.4577 0 001.94 7.5967A7.4007 7.4007 0 0027.64 14.041 5.4487 5.4487 0 0124.5974 15.8711z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowScatteredNight.propTypes = iconPropTypes;
}
const SnowDensity = /*#__PURE__*/React.forwardRef(function SnowDensity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowDensity.propTypes = iconPropTypes;
}
const Snowflake = /*#__PURE__*/React.forwardRef(function Snowflake({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Snowflake.propTypes = iconPropTypes;
}
const Soccer = /*#__PURE__*/React.forwardRef(function Soccer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "28",
    r: "2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 17.5H15.45V19.5H7.55z",
    transform: "rotate(-45 11.5 18.5)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.584L19.4143 8H6v2H18.5857l3 3L6 28.5859 7.4141 30 23 14.415 26.584 18 23 21.5859 24.4141 23 28 19.416A2.0044 2.0044 0 0028 16.584zM24.5 9A3.5 3.5 0 1128 5.5 3.504 3.504 0 0124.5 9zm0-5A1.5 1.5 0 1026 5.5 1.5017 1.5017 0 0024.5 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Soccer.propTypes = iconPropTypes;
}
const SoftwareResource = /*#__PURE__*/React.forwardRef(function SoftwareResource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoftwareResource.propTypes = iconPropTypes;
}
const SoftwareResourceCluster = /*#__PURE__*/React.forwardRef(function SoftwareResourceCluster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21c-.5 0-1-.2-1.4-.6l-3-3C19.2 17 19 16.5 19 16s.2-1 .6-1.4l3-3C23 11.2 23.5 11 24 11c.5 0 1 .2 1.4.6l3 3C28.8 15 29 15.5 29 16c0 .5-.2 1-.6 1.4l-3 3C25 20.8 24.5 21 24 21zM24 13l-3 3 3 3 3-3L24 13zM16 13c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3C15 3.2 15.5 3 16 3c.5 0 1 .2 1.4.6l3 3C20.8 7 21 7.5 21 8c0 .5-.2 1-.6 1.4l-3 3C17 12.8 16.5 13 16 13zM16 5l-3 3 3 3 3-3L16 5zM16 29c-.5 0-1-.2-1.4-.6l-3-3C11.2 25 11 24.5 11 24s.2-1 .6-1.4l3-3C15 19.2 15.5 19 16 19c.5 0 1 .2 1.4.6l3 3C20.8 23 21 23.5 21 24c0 .5-.2 1-.6 1.4l-3 3C17 28.8 16.5 29 16 29zM16 21l-3 3 3 3 3-3L16 21zM8 21c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3C7 11.2 7.5 11 8 11c.5 0 1 .2 1.4.6l3 3C12.8 15 13 15.5 13 16c0 .5-.2 1-.6 1.4l-3 3C9 20.8 8.5 21 8 21zM8 13l-3 3 3 3 3-3L8 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoftwareResourceCluster.propTypes = iconPropTypes;
}
const SoftwareResourceResource = /*#__PURE__*/React.forwardRef(function SoftwareResourceResource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 8.3H11.7V10.3H6.9z",
    transform: "rotate(-45.001 9.293 9.293)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 20.3H10.3V25.1H8.3z",
    transform: "rotate(-45.001 9.293 22.707)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 21.7H25.1V23.7H20.3z",
    transform: "rotate(-45.001 22.707 22.707)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 6.9H23.7V11.7H21.7z",
    transform: "rotate(-45.001 22.707 9.293)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoftwareResourceResource.propTypes = iconPropTypes;
}
const SoilMoisture = /*#__PURE__*/React.forwardRef(function SoilMoisture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "13",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "19",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "15",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "11",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "11",
    r: "1"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "21",
    r: "1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H30V8H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilMoisture.propTypes = iconPropTypes;
}
const SoilMoistureField = /*#__PURE__*/React.forwardRef(function SoilMoistureField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 30a5.202 5.202 0 01-4.626-8.08L23.49 16.5382a1.217 1.217 0 012.02 0L29.06 21.8154A5.4921 5.4921 0 0130 24.751 5.385 5.385 0 0124.5 30zm0-11.38l-2.9356 4.3672A3.2079 3.2079 0 0024.5 28 3.3855 3.3855 0 0028 24.751a3.4354 3.4354 0 00-.63-1.867zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilMoistureField.propTypes = iconPropTypes;
}
const SoilMoistureGlobal = /*#__PURE__*/React.forwardRef(function SoilMoistureGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a4.7347 4.7347 0 01-4.2075-7.35l3.3687-5.1942a1 1 0 011.6779 0l3.3152 5.11A4.9753 4.9753 0 0130 25.2231 4.8979 4.8979 0 0125 30zm0-10.1629l-2.5078 3.8662A2.9264 2.9264 0 1028 25.2231a2.96 2.96 0 00-.5444-1.6028zM11 24H9A17.0192 17.0192 0 0126 7h4V9H26A15.017 15.017 0 0011 24z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilMoistureGlobal.propTypes = iconPropTypes;
}
const SoilTemperature = /*#__PURE__*/React.forwardRef(function SoilTemperature({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "13",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "19",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "15",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "11",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "21",
    r: "1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM2 6H30V8H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilTemperature.propTypes = iconPropTypes;
}
const SoilTemperatureField = /*#__PURE__*/React.forwardRef(function SoilTemperatureField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2zM25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilTemperatureField.propTypes = iconPropTypes;
}
const SoilTemperatureGlobal = /*#__PURE__*/React.forwardRef(function SoilTemperatureGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM16 24H14a11.89 11.89 0 013.7642-8.7271l1.373 1.4542A9.909 9.909 0 0016 24z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilTemperatureGlobal.propTypes = iconPropTypes;
}
const SolarPanel = /*#__PURE__*/React.forwardRef(function SolarPanel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26V14H13V26h5v2H2v2H30V28H25V26zm-5-2V21h3v3zm-2-3v3H20V21zm-3-2V16h3v3zm8 0H25V16h3zM18 16v3H15V16zm-3 8V21h3v3zm8 4H20V26h3zM9.3328 14.981A4 4 0 1116 12H14a2 2 0 10-3.3333 1.4907zM11 2H13V6H11zM2 11H6V13H2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M5.343 4.343H7.343V8.343H5.343z",
    transform: "rotate(-45 6.343 6.343)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.657 4.343H18.657V8.343H16.657z",
    transform: "rotate(-135 17.657 6.343)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SolarPanel.propTypes = iconPropTypes;
}
const SortAscending = /*#__PURE__*/React.forwardRef(function SortAscending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 18H16V20H2zM6 12H16V14H6zM10 6H16V8H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortAscending.propTypes = iconPropTypes;
}
const SortDescending = /*#__PURE__*/React.forwardRef(function SortDescending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 6H16V8H2zM6 12H16V14H6zM10 18H16V20H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortDescending.propTypes = iconPropTypes;
}
const SortRemove = /*#__PURE__*/React.forwardRef(function SortRemove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415zM10 18H16V20H10zM2 6H16V8H2zM6 12H16V14H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortRemove.propTypes = iconPropTypes;
}
const SortingAToZ = /*#__PURE__*/React.forwardRef(function SortingAToZ({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M11,13c0-1.103-.8975-2-2-2h-5v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6v-8ZM9,19h-4v-2h4v2ZM16,2l-5,6h10l-5-6ZM16,30l5-6h-10l5,6ZM29,11h-8v2h5.5l-5.5,6v2h8v-2h-5.4927l5.4927-6v-2ZM19,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingAToZ.propTypes = iconPropTypes;
}
const SortingHighestToLowestNumber = /*#__PURE__*/React.forwardRef(function SortingHighestToLowestNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9756,2l-5,6h10l-5-6ZM15.9756,30l5-6h-10l5,6ZM24.9756,19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2ZM10.9756,19h-4v-2h2c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2ZM18.9756,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingHighestToLowestNumber.propTypes = iconPropTypes;
}
const SortingLowestToHighestNumber = /*#__PURE__*/React.forwardRef(function SortingLowestToHighestNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9756,2l-5,6h10l-5-6ZM15.9756,30l5-6h-10l5,6ZM10.9756,19h-2v-8h-2v1h-2v2h2v5h-2v2h6v-2ZM24.9756,17c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2h-4v-2h2ZM18.9756,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingLowestToHighestNumber.propTypes = iconPropTypes;
}
const SortingZToA = /*#__PURE__*/React.forwardRef(function SortingZToA({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11h-5v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6v-8c0-1.103-.8975-2-2-2ZM27,19h-4v-2h4v2ZM16,2l-5,6h10l-5-6ZM16,30l5-6h-10l5,6ZM11,19h-5.4927l5.4927-6v-2H3v2h5.5l-5.5,6v2h8v-2ZM19,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingZToA.propTypes = iconPropTypes;
}
const SpellCheck = /*#__PURE__*/React.forwardRef(function SpellCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2V17H26V6H6V26h6zM23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SpellCheck.propTypes = iconPropTypes;
}
const WatsonHealthSpineLabel = /*#__PURE__*/React.forwardRef(function WatsonHealthSpineLabel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11zM26 13H23V12H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V19h3a2 2 0 002-2V15A2 2 0 0026 13zm-8 4V15h8v2zM26 23H23V22H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V29h3a2 2 0 002-2V25A2 2 0 0026 23zm-8 4V25h8v2zM26 3H23V2H21V3H18a2 2 0 00-2 2V7a2 2 0 002 2h3v1h2V9h3a2 2 0 002-2V5A2 2 0 0026 3zM18 7V5h8V7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSpineLabel.propTypes = iconPropTypes;
}
const Split = /*#__PURE__*/React.forwardRef(function Split({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15zM15 14H17V18H15zM15 8H17V12H15z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Split.propTypes = iconPropTypes;
}
const WatsonHealthSplitDiscard = /*#__PURE__*/React.forwardRef(function WatsonHealthSplitDiscard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSplitDiscard.propTypes = iconPropTypes;
}
const SplitScreen = /*#__PURE__*/React.forwardRef(function SplitScreen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V28H15zM10 7V25H4V7h6m0-2H4A2 2 0 002 7V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zM28 7V25H22V7h6m0-2H22a2 2 0 00-2 2V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SplitScreen.propTypes = iconPropTypes;
}
const SprayPaint = /*#__PURE__*/React.forwardRef(function SprayPaint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8H26V3H19V8H17a2.002 2.002 0 00-2 2V28a2.0023 2.0023 0 002 2H28a2.0027 2.0027 0 002-2V10A2.0023 2.0023 0 0028 8zM21 5h3V8H21zM17 28V10H28l.002 18zM2 14H5V17H2zM7 9H10V12H7zM2 9H5V12H2zM12 4H15V7H12zM7 4H10V7H7zM2 4H5V7H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SprayPaint.propTypes = iconPropTypes;
}
const Sprout = /*#__PURE__*/React.forwardRef(function Sprout({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sprout.propTypes = iconPropTypes;
}
const SpyreAccelerator = /*#__PURE__*/React.forwardRef(function SpyreAccelerator({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M7,17c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM7,13c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM13,17c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM13,13c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM25,17c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM25,13c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM2,7v17h6v-3h3v4h16v-4h3V7H2ZM25,23h-12v-2h12v2ZM28,19H6v3h-2v-13h24v10ZM22,11h-6v6h6v-6ZM20,15h-2v-2h2v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SpyreAccelerator.propTypes = iconPropTypes;
}
const Sql = /*#__PURE__*/React.forwardRef(function Sql({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9H14a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H17V23h1a2 2 0 002-2V11A2 2 0 0018 9zM14 21V11h4V21zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sql.propTypes = iconPropTypes;
}
const SquareOutline = /*#__PURE__*/React.forwardRef(function SquareOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26,4H6c-1.1046,0-2,.8954-2,2v20c0,1.1046.8954,2,2,2h20c1.1046,0,2-.8954,2-2V6c0-1.1046-.8954-2-2-2ZM6,26V6h20v20H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SquareOutline.propTypes = iconPropTypes;
}
const SquareSolid = /*#__PURE__*/React.forwardRef(function SquareSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 32V0h32v32z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SquareSolid.propTypes = iconPropTypes;
}
const SquareFill = /*#__PURE__*/React.forwardRef(function SquareFill({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
      d: "M3 3H13V13H3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H13V13H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SquareFill.propTypes = iconPropTypes;
}
const StackLimitation = /*#__PURE__*/React.forwardRef(function StackLimitation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H16V30H8zM24 12H20v2h4v2H21v2h3v2H20v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0024 12zM16 20H8V12h8zm-6-2h4V14H10zM16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StackLimitation.propTypes = iconPropTypes;
}
const WatsonHealthStackedMove = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedMove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStackedMove.propTypes = iconPropTypes;
}
const WatsonHealthStackedScrolling_1 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStackedScrolling_1.propTypes = iconPropTypes;
}
const WatsonHealthStackedScrolling_2 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStackedScrolling_2.propTypes = iconPropTypes;
}
const Stamp = /*#__PURE__*/React.forwardRef(function Stamp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stamp.propTypes = iconPropTypes;
}
const Star = /*#__PURE__*/React.forwardRef(function Star({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
      d: "M8,3.3l1.4,2.8l0.2,0.5l0.5,0.1l3.1,0.4L11,9.2l-0.4,0.4l0.1,0.5l0.5,3.1l-2.8-1.4L8,11.5l-0.5,0.2l-2.8,1.4l0.5-3.1 l0.1-0.5L5,9.2L2.8,7l3.1-0.4l0.5-0.1L6.6,6L8,3.3 M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7 L8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Star.propTypes = iconPropTypes;
}
const StarFilled = /*#__PURE__*/React.forwardRef(function StarFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7L8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StarFilled.propTypes = iconPropTypes;
}
const StarHalf = /*#__PURE__*/React.forwardRef(function StarHalf({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
      d: "M5.7 5.6L0.6 6.3 4.3 9.9 3.5 15 8 12.6 8 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StarHalf.propTypes = iconPropTypes;
}
const StarReview = /*#__PURE__*/React.forwardRef(function StarReview({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StarReview.propTypes = iconPropTypes;
}
const WatsonHealthStatusAcknowledge = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusAcknowledge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusAcknowledge.propTypes = iconPropTypes;
}
const WatsonHealthStatusChange = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusChange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusChange.propTypes = iconPropTypes;
}
const WatsonHealthStatusPartialFail = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusPartialFail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusPartialFail.propTypes = iconPropTypes;
}
const WatsonHealthStatusResolved = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusResolved({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusResolved.propTypes = iconPropTypes;
}
const StayInside = /*#__PURE__*/React.forwardRef(function StayInside({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StayInside.propTypes = iconPropTypes;
}
const StemLeafPlot = /*#__PURE__*/React.forwardRef(function StemLeafPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StemLeafPlot.propTypes = iconPropTypes;
}
const Stethoscope = /*#__PURE__*/React.forwardRef(function Stethoscope({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stethoscope.propTypes = iconPropTypes;
}
const Stickies = /*#__PURE__*/React.forwardRef(function Stickies({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22v-12c0-1.1-.9-2-2-2H12c-1.1,0-2,.9-2,2v18c0,1.1.9,2,2,2h10c.3,0,.5-.1.7-.3l7-7c.2-.2.3-.4.3-.7ZM22,22h5.6s-5.6,5.6-5.6,5.6v-5.6ZM28,20h-6c-1.1,0-2,.9-2,2v6h-8V10h16v10Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M4,22V4h16v2h2v-2c0-1.1001-.8999-2-2-2H4c-1.1001,0-2,.8999-2,2v18c0,1.1001.8999,2,2,2h4v-2H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stickies.propTypes = iconPropTypes;
}
const Stop = /*#__PURE__*/React.forwardRef(function Stop({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
      d: "M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stop.propTypes = iconPropTypes;
}
const StopFilled = /*#__PURE__*/React.forwardRef(function StopFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4 c0.6,0,1,0.4,1,1V10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopFilled.propTypes = iconPropTypes;
}
const StopFilledAlt = /*#__PURE__*/React.forwardRef(function StopFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopFilledAlt.propTypes = iconPropTypes;
}
const StopOutline = /*#__PURE__*/React.forwardRef(function StopOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
      d: "M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopOutline.propTypes = iconPropTypes;
}
const StopOutlineFilled = /*#__PURE__*/React.forwardRef(function StopOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4 c0.6,0,1,0.4,1,1V10z"
    })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
      d: "M6 6H10V10H6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V20H12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopOutlineFilled.propTypes = iconPropTypes;
}
const StopSign = /*#__PURE__*/React.forwardRef(function StopSign({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopSign.propTypes = iconPropTypes;
}
const StopSignFilled = /*#__PURE__*/React.forwardRef(function StopSignFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopSignFilled.propTypes = iconPropTypes;
}
const StoragePool = /*#__PURE__*/React.forwardRef(function StoragePool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StoragePool.propTypes = iconPropTypes;
}
const StorageRequest = /*#__PURE__*/React.forwardRef(function StorageRequest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "12",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StorageRequest.propTypes = iconPropTypes;
}
const Store = /*#__PURE__*/React.forwardRef(function Store({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Store.propTypes = iconPropTypes;
}
const StormTracker = /*#__PURE__*/React.forwardRef(function StormTracker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StormTracker.propTypes = iconPropTypes;
}
const StrategyPlay = /*#__PURE__*/React.forwardRef(function StrategyPlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 3.415L10.586 2 7 5.587 3.414 2 2 3.415 5.586 7 2 10.586 3.414 12 7 8.414 10.586 12 12 10.586 8.414 7 12 3.415zM25 2l-5 5 1.4089 1.4189 2.5911-2.625v9.2061H8c-1.1028 0-2 .8975-2 2v3.1011c-2.2793.4644-4 2.4844-4 4.8989 0 2.7568 2.2429 5 5 5s5-2.2432 5-5c0-2.4146-1.7207-4.4346-4-4.8989v-3.1011h16c1.1028 0 2-.8975 2-2V5.8472l2.5911 2.5718 1.4089-1.4189-5-5zm-15 23c0 1.6543-1.3457 3-3 3s-3-1.3457-3-3 1.3457-3 3-3 3 1.3457 3 3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M30 21.415L28.586 20 25 23.587 21.414 20 20 21.415 23.586 25 20 28.586 21.414 30 25 26.414 28.586 30 30 28.586 26.414 25 30 21.415z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StrategyPlay.propTypes = iconPropTypes;
}
const Strawberry = /*#__PURE__*/React.forwardRef(function Strawberry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Strawberry.propTypes = iconPropTypes;
}
const WatsonHealthStressBreathEditor = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStressBreathEditor.propTypes = iconPropTypes;
}
const StringInteger = /*#__PURE__*/React.forwardRef(function StringInteger({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StringInteger.propTypes = iconPropTypes;
}
const StringText = /*#__PURE__*/React.forwardRef(function StringText({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StringText.propTypes = iconPropTypes;
}
const WatsonHealthStudyNext = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyNext.propTypes = iconPropTypes;
}
const WatsonHealthStudyPrevious = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyPrevious.propTypes = iconPropTypes;
}
const WatsonHealthStudyRead = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyRead({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyRead.propTypes = iconPropTypes;
}
const WatsonHealthStudySkip = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudySkip.propTypes = iconPropTypes;
}
const WatsonHealthStudyTransfer = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyTransfer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyTransfer.propTypes = iconPropTypes;
}
const WatsonHealthStudyUnread = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyUnread({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyUnread.propTypes = iconPropTypes;
}
const WatsonHealthStudyView = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyView.propTypes = iconPropTypes;
}
const WatsonHealthSubVolume = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSubVolume.propTypes = iconPropTypes;
}
const Subclassification = /*#__PURE__*/React.forwardRef(function Subclassification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,28v-10h7c.3564,0,.686-.1899.8647-.498.0902-.1551.1353-.3285.1353-.502,0-.1711-.0441-.3424-.1318-.4961L12.8682,2.504c-.1919-.3359-.5301-.504-.8682-.504s-.6763.1681-.8682.504l-7.9999,13.9999c-.0878.1537-.1318.3249-.1318.4961,0,.1735.0451.3469.1353.502.1787.3081.5083.498.8647.498h7v10c0,1.1046.8954,2,2,2h15v-2h-15Zm-7.2769-12l6.2769-10.9844,6.2769,10.9844H5.7231Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subclassification.propTypes = iconPropTypes;
}
const Subdirectory = /*#__PURE__*/React.forwardRef(function Subdirectory({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m9,20l1.4141,1.4141-2.5859,2.5859h18.1719s0-20,0-20h2v20c0,1.1025-.897,2-2,2H7.8281s2.5859,2.5859,2.5859,2.5859l-1.4141,1.4141-5-5,5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subdirectory.propTypes = iconPropTypes;
}
const Subflow = /*#__PURE__*/React.forwardRef(function Subflow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subflow.propTypes = iconPropTypes;
}
const SubflowLocal = /*#__PURE__*/React.forwardRef(function SubflowLocal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubflowLocal.propTypes = iconPropTypes;
}
const SubjectDefinition = /*#__PURE__*/React.forwardRef(function SubjectDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M22.7749 20.5022h-.0862c-.3101.8959-1.0334 1.7056-2.5151 1.7056-1.8433 0-2.877-1.2749-2.877-3.5144v-5.6849h2.2051v5.4609c0 1.2404.4651 1.9122 1.5161 1.9122.8784 0 1.7571-.4651 1.7571-1.4298v-5.9434h2.2051v8.9926h-2.2051v-1.4988zM6.6195 20.2094l1.5332-1.4816c.8269.9647 1.8433 1.4816 3.0837 1.4816 1.3953 0 2.1189-.6719 2.1189-1.6882 0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971 0-2.1534 1.6709-3.5488 4.3584-3.5488 1.8088 0 3.1526.6202 4.1172 1.7744l-1.5503 1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292 0-1.9639.5168-1.9639 1.4126 0 .9131.5168 1.292 1.6711 1.4988l1.1196.2067c2.429.4308 3.5662 1.516 3.5662 3.4972 0 2.2739-1.6367 3.8245-4.5137 3.8245-2.05 0-3.4626-.8097-4.479-1.9984z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubjectDefinition.propTypes = iconPropTypes;
}
const SubjectUsage = /*#__PURE__*/React.forwardRef(function SubjectUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M22.7749 20.5022h-.0862c-.3101.8959-1.0334 1.7056-2.5151 1.7056-1.8433 0-2.877-1.2749-2.877-3.5144v-5.6849h2.2051v5.4609c0 1.2404.4651 1.9122 1.5161 1.9122.8784 0 1.7571-.4651 1.7571-1.4298v-5.9434h2.2051v8.9926h-2.2051v-1.4988zM6.6195 20.2094l1.5332-1.4816c.8269.9647 1.8433 1.4816 3.0837 1.4816 1.3953 0 2.1189-.6719 2.1189-1.6882 0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971 0-2.1534 1.6709-3.5488 4.3584-3.5488 1.8088 0 3.1526.6202 4.1172 1.7744l-1.5503 1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292 0-1.9639.5168-1.9639 1.4126 0 .9131.5168 1.292 1.6711 1.4988l1.1196.2067c2.429.4308 3.5662 1.516 3.5662 3.4972 0 2.2739-1.6367 3.8245-4.5137 3.8245-2.05 0-3.4626-.8097-4.479-1.9984z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubjectUsage.propTypes = iconPropTypes;
}
const SubnetAclRules = /*#__PURE__*/React.forwardRef(function SubnetAclRules({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubnetAclRules.propTypes = iconPropTypes;
}
const Subsetting = /*#__PURE__*/React.forwardRef(function Subsetting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8682,16.5039L16.8682,2.5039c-.356-.623-1.3804-.623-1.7363,0l-8,14c-.177.3096-.1758.6895.0032.998.179.3081.5085.498.865.498h7v12h2v-12h7c.3564,0,.686-.1899.865-.498.179-.3086.1802-.6885.0032-.998ZM9.7231,16l6.2769-10.9844,6.2769,10.9844h-12.5537Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subsetting.propTypes = iconPropTypes;
}
const Subtract = /*#__PURE__*/React.forwardRef(function Subtract({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subtract.propTypes = iconPropTypes;
}
const SubtractAlt = /*#__PURE__*/React.forwardRef(function SubtractAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14 S23.7,2,16,2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubtractAlt.propTypes = iconPropTypes;
}
const SubtractFilled = /*#__PURE__*/React.forwardRef(function SubtractFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6,0-14,6.4-14,14s6.4,14,14,14,14-6.4,14-14S23.6,2,16,2Zm8,15H8v-2h16v2Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L8 17 8 15 24 15 24 17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubtractFilled.propTypes = iconPropTypes;
}
const SubtractLarge = /*#__PURE__*/React.forwardRef(function SubtractLarge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15L5 17 27 17 27 15 5 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubtractLarge.propTypes = iconPropTypes;
}
const Succession = /*#__PURE__*/React.forwardRef(function Succession({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M19 27H21V31H19z",
    transform: "rotate(90 20 29)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M25 27H27V31H25z",
    transform: "rotate(90 26 29)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M13 28v-3h-2v3c0 1.1046.8954 2 2 2h3v-2h-3zM11 19H13V23H11zM11 13H13V17H11z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M22 12L12 2 2 12 3.4141 13.4141 11 5.8281 11 11 13 11 13 5.8281 20.5859 13.4141 22 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Succession.propTypes = iconPropTypes;
}
const SuccessionFlowConnection = /*#__PURE__*/React.forwardRef(function SuccessionFlowConnection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M7,3v2s-5,0-5,0v-2s5,0,5,0ZM13,16h2s0-5,0-5h-2s0,5,0,5ZM15,5c0-1.1028-.8972-2-2-2h-4v2h4v4h2v-4ZM19,22h-4v-4h-2v4c0,1.1028.8972,2,2,2h4v-2ZM30.6001,22.2002l-8-6c-.303-.2275-.7083-.2642-1.0474-.0947-.3386.1694-.5527.5156-.5527.8945v12c0,.3789.2141.7251.5527.8945.1416.0708.2947.1055.447.1055.2126,0,.4238-.0674.6003-.2002l8-6c.2517-.1885.3999-.4849.3999-.7998s-.1482-.6113-.3999-.7998Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SuccessionFlowConnection.propTypes = iconPropTypes;
}
const SummaryKpi = /*#__PURE__*/React.forwardRef(function SummaryKpi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SummaryKpi.propTypes = iconPropTypes;
}
const SummaryKpiMirror = /*#__PURE__*/React.forwardRef(function SummaryKpiMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SummaryKpiMirror.propTypes = iconPropTypes;
}
const Sun = /*#__PURE__*/React.forwardRef(function Sun({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sun.propTypes = iconPropTypes;
}
const Sunrise = /*#__PURE__*/React.forwardRef(function Sunrise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.146 15.854)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.854 15.854)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H7V24H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sunrise.propTypes = iconPropTypes;
}
const Sunset = /*#__PURE__*/React.forwardRef(function Sunset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.005H29.998V29.005H2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
    transform: "translate(0 .005)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.005H30V24.005H25z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.152 15.856)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.86 15.856)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22.005H7V24.005H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sunset.propTypes = iconPropTypes;
}
const SupportVectorMachine = /*#__PURE__*/React.forwardRef(function SupportVectorMachine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "18",
    r: "4"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "4"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.799 15H34.799V17H-2.799z",
    transform: "rotate(-45 16 16)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2zM6 18c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SupportVectorMachine.propTypes = iconPropTypes;
}
const SurrogateKeyDatabase = /*#__PURE__*/React.forwardRef(function SurrogateKeyDatabase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15c-2.8,0-5,2.2-5,5,0,.2,0,.4,0,.6l-5,5v4.4h4.4s5-5,5-5c.2,0,.4,0,.6,0,2.8,0,5-2.2,5-5s-2.2-5-5-5ZM28,20.7c-.4,1.6-2,2.6-3.7,2.2h-.5c0-.1-5.2,5.1-5.2,5.1h-1.6v-1.6l5.2-5.2v-.5c-.2-.5-.2-.9-.1-1.4.4-1.6,2-2.6,3.7-2.2,1.6.4,2.6,2,2.2,3.7ZM26,19.9c0,.6-.4,1-1,1s-1-.4-1-1,.4-1,1-1,1,.4,1,1ZM6,13h18V5c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v22c0,1.1.9,2,2,2h7v-2h-7v-6h7v-2h-7v-6ZM6,5h16v6H6v-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SurrogateKeyDatabase.propTypes = iconPropTypes;
}
const SurrogateKeyFlatFile = /*#__PURE__*/React.forwardRef(function SurrogateKeyFlatFile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9969,14.9969c-2.7614.0017-4.9986,2.2417-4.9969,5.0031.0002.1845.0114.3688.0337.552l-5.0337,5.0337v4.4143h4.4141l5.0337-5.0337c.1844.0205.3698.0307.5553.0306,2.7614-.0017,4.9986-2.2417,4.9969-5.0031s-2.2417-4.9986-5.0031-4.9969ZM27.9874,20.6685c-.3885,1.6306-2.0253,2.6375-3.6559,2.249l-.5395-.1238-5.2061,5.2063h-1.5859v-1.5857l5.2061-5.2063-.1236-.5393c-.1103-.4625-.1103-.9445,0-1.407.3884-1.6306,2.0253-2.6376,3.6558-2.2491,1.6306.3885,2.6376,2.0253,2.2491,3.6559ZM25.9646,20c0,.5523-.4477,1-1,1s-1-.4477-1-1,.4478-1,1-1,1,.4477,1,1ZM22.2918,12.0002c.6929,0,1.312-.4136,1.5771-1.0537.2656-.6406.1201-1.3711-.3701-1.8613l-6.792-6.792c-.1875-.1875-.4419-.293-.707-.293H5.9998c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h7.011v-2h-7.011V4.0002h8v6c0,1.1025.897,2,2,2h6.292ZM15.9998,4.4142l5.5854,5.5859h-5.5854v-5.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SurrogateKeyFlatFile.propTypes = iconPropTypes;
}
const Sustainability = /*#__PURE__*/React.forwardRef(function Sustainability({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5708,27.7495c-1.7468.8296-3.6211,1.2505-5.5708,1.2505-7.1682,0-13-5.832-13-13,0-3.0752,1.0571-5.979,3-8.3076v2.3076h2v-6H2v2h2.8416c-2.4753,2.7539-3.8416,6.2622-3.8416,10,0,8.271,6.729,15,15,15,2.249,0,4.4119-.4858,6.4292-1.4438l-.8584-1.8066Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m21,9c-3.1602,0-5.7515,2.457-5.9778,5.5605-1.0654-.9658-2.4739-1.5605-4.0222-1.5605h-4v4c0,3.3086,2.6917,6,6,6h2v4h2v-8.0005l2,.0005c3.3083,0,6-2.6914,6-6v-4h-4Zm-8,12c-2.2056,0-4-1.7944-4-4v-2h2c2.2056,0,4,1.7944,4,4v.5859l-2.293-2.293-1.4141,1.4141,2.293,2.293h-.5859Zm10-8c0,2.2056-1.7944,4-4,4h-.5859l2.293-2.293-1.4141-1.4141-2.293,2.293v-.5859c0-2.2056,1.7944-4,4-4h2v2Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m31,16c0-8.271-6.729-15-15-15-2.249,0-4.4119.4858-6.4292,1.4438l.8584,1.8066c1.7468-.8296,3.6211-1.2505,5.5708-1.2505,7.1682,0,13,5.832,13,13,0,3.0752-1.0571,5.979-3,8.3076v-2.3076h-2v6h6v-2h-2.8416c2.4753-2.7539,3.8416-6.2622,3.8416-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sustainability.propTypes = iconPropTypes;
}
const Svg = /*#__PURE__*/React.forwardRef(function Svg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Svg.propTypes = iconPropTypes;
}
const Swim = /*#__PURE__*/React.forwardRef(function Swim({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Swim.propTypes = iconPropTypes;
}
const SwimlaneDVertical = /*#__PURE__*/React.forwardRef(function SwimlaneDVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M25,26h2v4h-4v-2h2v-2ZM17,30h4v-2h-4v2ZM7,26h-2v4h4v-2h-2v-2ZM7,19.9995h-2v4.0005h2v-4.0005ZM7,14h-2v4h2v-4ZM5,8v3.9995h2v-1.9995h2v-2h-4ZM5,6h2v-2h2v-2h-4v4ZM17,4h4v-2h-4v2ZM11,4h4v-2h-4v2ZM23,2v2h2v2h2V2h-4ZM25,24h2v-3.9995h-2v3.9995ZM25,18h2v-4h-2v4ZM17,10h4v-2h-4v2ZM11,10h4v-2h-4v2ZM23,8v2h2v2h2v-4h-4ZM11,30h4v-2h-4v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SwimlaneDVertical.propTypes = iconPropTypes;
}
const SwitchLayer_2 = /*#__PURE__*/React.forwardRef(function SwitchLayer_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SwitchLayer_2.propTypes = iconPropTypes;
}
const SwitchLayer_3 = /*#__PURE__*/React.forwardRef(function SwitchLayer_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SwitchLayer_3.propTypes = iconPropTypes;
}
const Switcher = /*#__PURE__*/React.forwardRef(function Switcher({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Switcher.propTypes = iconPropTypes;
}
const SyncSettings = /*#__PURE__*/React.forwardRef(function SyncSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M15 24L15 22 11.4 22 22 11.4 22 15 24 15 24 8 17 8 17 10 20.6 10 10 20.6 10 17 8 17 8 24 15 24zM25 20v2h3c1.1 0 2-.9 2-2v-3h-2v3h-3zM28 10H30V14H28zM25 2v2h3v3h2v-3c0-1.1-.9-2-2-2h-3zM18 2H22V4H18z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 4v3h2v-3h3V2h-3c-1.1 0-2 .9-2 2zM12 10H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8h-2v8H4V12h8v-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SyncSettings.propTypes = iconPropTypes;
}
const SysProvision = /*#__PURE__*/React.forwardRef(function SysProvision({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L21 30 30 25 21 20z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SysProvision.propTypes = iconPropTypes;
}
const SysplexDistributor = /*#__PURE__*/React.forwardRef(function SysplexDistributor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 18h-8v-2h-2v2H7c-1.1028 0-2 .8975-2 2v4h2v-4h8v4h2v-4h8v4h2v-4c0-1.1025-.8972-2-2-2zM20 2h-8c-1.1028 0-2 .8975-2 2v8c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V4c0-1.1025-.8972-2-2-2zm-1.4141 2l-6.5859 6.5859v-6.5859h6.5859zm-5.1719 8l6.5862-6.5859.001 6.5859h-6.5872z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SysplexDistributor.propTypes = iconPropTypes;
}
const QT = /*#__PURE__*/React.forwardRef(function QT({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QT.propTypes = iconPropTypes;
}
const QTAlt = /*#__PURE__*/React.forwardRef(function QTAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QTAlt.propTypes = iconPropTypes;
}

export { QT, QTAlt, SkipForwardFilled, SkipForwardOutline, SkipForwardOutlineFilled, SkipForwardOutlineSolid, SkipForwardSolidFilled, Sleet, Slisor, Slm, Smell, Smoke, Snooze, Snow, SnowBlizzard, SnowDensity, SnowHeavy, SnowScattered, SnowScatteredNight, Snowflake, Soccer, SoftwareResource, SoftwareResourceCluster, SoftwareResourceResource, SoilMoisture, SoilMoistureField, SoilMoistureGlobal, SoilTemperature, SoilTemperatureField, SoilTemperatureGlobal, SolarPanel, SortAscending, SortDescending, SortRemove, SortingAToZ, SortingHighestToLowestNumber, SortingLowestToHighestNumber, SortingZToA, SpellCheck, Split, SplitScreen, SprayPaint, Sprout, SpyreAccelerator, Sql, SquareFill, SquareOutline, SquareSolid, StackLimitation, Stamp, Star, StarFilled, StarHalf, StarReview, StayInside, StemLeafPlot, Stethoscope, Stickies, Stop, StopFilled, StopFilledAlt, StopOutline, StopOutlineFilled, StopSign, StopSignFilled, StoragePool, StorageRequest, Store, StormTracker, StrategyPlay, Strawberry, StringInteger, StringText, Subclassification, Subdirectory, Subflow, SubflowLocal, SubjectDefinition, SubjectUsage, SubnetAclRules, Subsetting, Subtract, SubtractAlt, SubtractFilled, SubtractLarge, Succession, SuccessionFlowConnection, SummaryKpi, SummaryKpiMirror, Sun, Sunrise, Sunset, SupportVectorMachine, SurrogateKeyDatabase, SurrogateKeyFlatFile, Sustainability, Svg, Swim, SwimlaneDVertical, SwitchLayer_2, SwitchLayer_3, Switcher, SyncSettings, SysProvision, SysplexDistributor, WatsonHealthSmoothing, WatsonHealthSmoothingCursor, WatsonHealthSpineLabel, WatsonHealthSplitDiscard, WatsonHealthStackedMove, WatsonHealthStackedScrolling_1, WatsonHealthStackedScrolling_2, WatsonHealthStatusAcknowledge, WatsonHealthStatusChange, WatsonHealthStatusPartialFail, WatsonHealthStatusResolved, WatsonHealthStressBreathEditor, WatsonHealthStudyNext, WatsonHealthStudyPrevious, WatsonHealthStudyRead, WatsonHealthStudySkip, WatsonHealthStudyTransfer, WatsonHealthStudyUnread, WatsonHealthStudyView, WatsonHealthSubVolume };
